export const API_URL = 'https://manage.discoveryapp.io/api/beta';
export const API_OAUTH_URL = 'https://manage.discoveryapp.io/oauth';
export const API_CLIENT_ID = 9001;
export const APP_NAME = 'Discovery Client Portal';
